import React, { useEffect, useState } from "react";
import Select from "react-select";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as validationService from "../add-device-modal/validationService";

const criticalityOptions = [
    { value: "High", label: "High", tone: "high" },
    { value: "Medium", label: "Medium", tone: "medium" },
    { value: "Low", label: "Low", tone: "low" }
];

function CriticalityOptionLabel({ label, tone }) {
    return (
        <span className="modal-v2-criticality-option">
            <span className={`modal-v2-criticality-dot is-${tone}`} aria-hidden="true" />
            <span>{label}</span>
        </span>
    );
}

function CriticalityField({ value, onChange, error, disabled }) {
    useEffect(() => {
        validationService.validateNotEmpty(value, 'criticality');
        return () => validationService.cleanValidation('criticality');
    }, [value]);

    const [touched, setTouched] = useState(false);
    const menuPortalTarget = typeof document !== "undefined" ? document.body : null;
    const selectedOption = criticalityOptions.find((option) => option.value === value) || null;

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="criticality">Criticality Level <span className="modal-v2-required-mark">*</span></label>
                <Select
                    inputId="criticality"
                    instanceId="criticality-edit"
                    className={`oct_selectsearch-v2 modal-v2-criticality-select ${(error && touched) ? "border-danger" : ""}`}
                    classNamePrefix="oct-selectsearchsub-v2"
                    isSearchable={false}
                    isDisabled={disabled}
                    value={selectedOption}
                    onChange={(option) => {
                        if (!disabled) {
                            onChange(option?.value || "");
                            setTouched(true);
                        }
                    }}
                    options={criticalityOptions}
                    formatOptionLabel={(option) => (
                        <CriticalityOptionLabel label={option.label} tone={option.tone} />
                    )}
                    menuPlacement="auto"
                    menuPosition="fixed"
                    menuPortalTarget={menuPortalTarget}
                />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("CriticalityField mapStateToProps", state);
    const validation = state.validation;
    return {
        error: validation.criticality
    };
}

export default connect(mapStateToProps)(CriticalityField);
